<script setup lang="ts">
import type { CmsElementSmallTextBox } from "~/composables/useCustom";

const props = defineProps<{
  content: CmsElementSmallTextBox;
  class: any;
  style: any;
}>();

const { heading, subHeading } = props.content?.config

</script>
<template>
  <section v-if="heading" class="section section-about section--solid" :style="props.style" :class="props.class">
    <div class="container">
      <div class="section__body">
        <div class="section__content">
          <h2>{{ heading.value }}</h2>
          <p>{{ subHeading.value }}</p>
        </div><!-- /.section__content -->
      </div><!-- /.section__body -->
    </div><!-- /.container -->
  </section>
</template>